import type { PawSightEnvironment } from '@chewy/audio-to-notes-ui'
import { Utils } from '@pbt/pbt-ui-components'

/**
 * Maps Rhapsody environment to Chewy PawSight environment.
 *
 * @returns PawSight environment ('qat', 'stg', 'prd')
 */
export const useAudioRecorderEnvironment = (): PawSightEnvironment => {
  const rhapsodyEnv = Utils.getEnvironmentName()

  // Map Rhapsody environments to Chewy PawSight environments
  // getEnvironmentName() returns: 'Staging', 'Production', 'Play', 'Local'
  const environmentMap: Record<string, PawSightEnvironment> = {
    Staging: 'qat', // Rhapsody staging → Chewy qat
    Play: 'stg', // Rhapsody play/master → Chewy stg
    Production: 'prd', // Rhapsody production → Chewy prd
  }

  // Check for local development (when getEnvironmentName() returns 'Local' or hostname is localhost)
  const isLocal =
    Utils.isLocalEnvironment?.() ?? window.location.hostname === 'localhost'

  // Use mapped environment if available, otherwise default to 'qat' for local
  // (portal local dev connects to QAT Rhapsody, so PawSight calls should target QAT too)
  return environmentMap[rhapsodyEnv] || (isLocal ? 'qat' : 'prd')
}
